module.exports = __webpack_public_path__ + "static/media/request-approval-svgrepo-com.c8538292.svg";